import { Navigate, Outlet } from 'react-router-dom';
import { useCurrentUser } from '@/hooks/use-current-user';
import { FullPageLoader } from 'prosci-ui';

export function SuperAdminRoute() {
  const { data: currentUser, isLoading } = useCurrentUser();

  if (isLoading) {
    return <FullPageLoader message="Loading..." />;
  }

  // Check if user is a super admin
  const isSuperAdmin = currentUser?.type === 'prosci_admin' && currentUser?.level === 'super';

  if (!isSuperAdmin) {
    // Redirect to users page if not a super admin
    return <Navigate to="/users" replace />;
  }

  return <Outlet />;
}